<h2 mat-dialog-title>Your session has expired</h2>
<mat-dialog-content class="mat-typography">
 <p>If you want to continue your work, please reauthenticate and redo your last action.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button style="margin-right: 10px" mat-button mat-dialog-close>Logout</button>
  <div id="googleLoginButton"></div>
</mat-dialog-actions>
